import GeneralInformationApi from "../api/GeneralInformationApi";

export default {
    getGeneralInformation: async () => {
        const response = await GeneralInformationApi.getGeneralInformation(); 
        return response;
    },
    updateGeneralInformation: async (data) => {
        const response = await GeneralInformationApi.updateGeneralInformation(data); 
        return response;
    },
};